module.exports = __webpack_public_path__ + "media/images/lb/668-fba615b6d0f54fd8430084dd488c25d5.svg";